import { render, staticRenderFns } from "./submitCertificate.vue?vue&type=template&id=20468b30&scoped=true"
import script from "./submitCertificate.vue?vue&type=script&lang=js"
export * from "./submitCertificate.vue?vue&type=script&lang=js"
import style0 from "./submitCertificate.vue?vue&type=style&index=0&id=20468b30&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20468b30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20468b30')) {
      api.createRecord('20468b30', component.options)
    } else {
      api.reload('20468b30', component.options)
    }
    module.hot.accept("./submitCertificate.vue?vue&type=template&id=20468b30&scoped=true", function () {
      api.rerender('20468b30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/offlinePayment/components/submitCertificate.vue"
export default component.exports